/** Caratteri non consentiti nei nomi di cartella (Windows + cross-platform + caratteri speciali) */
const INVALID_CHARS = /[\\/:*?"<>|°#%&{}@!`~\u0000-\u001f]/g;

export function sanitizeFolderName(name: string): string {
  if (!name || typeof name !== 'string') return 'ATTIVITA';
  let s = name
    .replace(INVALID_CHARS, '_')
    .replace(/\s+/g, ' ')
    .trim();
  // Windows: rimuovi punti e spazi finali (loop perché la rimozione di punti può esporre spazi)
  s = s.replace(/[\s.]+$/, '');
  return s || 'ATTIVITA';
}
